import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { IContentDetail } from 'src/interface';

interface IProps {
    content: IContentDetail | undefined;
}
export function GATracking({ content }: IProps) {
    const [showIframe, setShowIframe] = useState<boolean>(false);
    const iframeRef: MutableRefObject<HTMLElement | any> = useRef(null);
    const intervalRef: MutableRefObject<any> = useRef(1);

    useEffect(() => {
        if (content) {
            const { publisher, originalUrl = '', redirectUrl } = content;

            setTimeout(() => {
                if (publisher && publisher?.gaId) {
                    // ReactGA.addTrackers([
                    //     {
                    //         trackingId: publisher.gaId,
                    //         gaOptions: {
                    //             name: 'trackDetail' + publisher.id,
                    //         },
                    //     },
                    // ]);

                    const current = new Date().getTime() % 100;
                    const gaRatio = publisher.gaRatio;

                    if (gaRatio && current <= gaRatio) {
                        // ReactGA.set({ referrer: redirectUrl }, [
                        //     'trackDetail' + publisher.id,
                        // ]);
                        // ReactGA.pageview(originalUrl, [
                        //     'trackDetail' + publisher.id,
                        // ]);

                        if (publisher?.ga4Id) {
                            setShowIframe(true);
                        }
                    }
                }
            }, 100);
        }
    }, [content]);

    useEffect(() => {
        if (!showIframe) {
            return;
        }

        if (intervalRef && intervalRef.current) {
            intervalRef.current = setInterval(() => {
                const {
                    publisher,
                    originalUrl = '',
                    redirectUrl,
                    title,
                    url,
                } = content || {};

                if (publisher && iframeRef.current) {
                    const body = iframeRef.current.contentWindow.document.body;
                    if (!body) {
                        return;
                    }

                    clearInterval(intervalRef.current);
                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = `https://www.googletagmanager.com/gtag/js?id=${publisher.ga4Id}`;

                    const script2 = document.createElement('script');
                    script2.type = 'text/javascript';

                    // prettier-ignore
                    const text =
                        'window.dataLayer = window.dataLayer || []; \n' +
                        'function gtag(){window.dataLayer.push(arguments);} \n' +
                        'gtag("js", new Date()); \n' +
                        'gtag("config", "' + publisher.ga4Id + '", {\n' +
                            'page_title: "' + title + '",\n' +
                            'page_location: "' + url + '",\n' +
                            'page_referrer: "' + redirectUrl + '",\n' +
                            'page_path: "' + originalUrl + '"\n' +
                        '})';

                    script2.text = text;
                    body.appendChild(script);
                    body.appendChild(script2);
                }
            }, 1000); // waiting for iframe loading page
        }

        return () => {
            clearInterval(intervalRef.current);
        };

    }, [showIframe]);

    useEffect(() => {
        return () => {
            setShowIframe(false);
        };
    }, [content]);

    return showIframe ? (
        <iframe
            id="iframe"
            ref={iframeRef}
            width={0}
            height={0}
            style={{
                border: 'none',
                position: 'absolute',
            }}
            src="/tracking.epi"
        ></iframe>
    ) : (
        <></>
    );
}
